export enum LabUpdateEntityType {    
    Donor = 1,
    Recipient = 2
}